export const messages = {
  en: {
    queryStockManage: {
      title: 'Stock Query',
      searchCondition: 'Search Condition',
      stockQuery: 'Stock Query',
      productName: 'Product Name',
      productId: 'Product ID',
      status: 'Status',
      warehouse: 'Warehouse',
      barcode: 'Barcode',
      specification: 'Specification',
      unit: 'Unit',
      stock: 'Stock',
      purchaseCount: 'Purchase Count',
      returnCount: 'Return Count',
      aboutToExpire: 'About To Expire',
      loss: 'Loss',
      state: 'State',
      search: 'Search',
      reset: 'Reset'
    }
  },
  zh: {
    queryStockManage: {
      title: '库存查询',
      searchCondition: '查询条件',
      stockQuery: '库存查询',
      productName: '商品名称',
      productId: '商品编号',
      status: '状态',
      warehouse: '仓库',
      barcode: '商品条码',
      specification: '商品规格',
      unit: '商品单位',
      stock: '库存',
      purchaseCount: '进货次数',
      returnCount: '退货次数',
      aboutToExpire: '将过期',
      loss: '耗损',
      state: '状态',
      search: '查询',
      reset: '重置'
    }
  }
}